export default "__VITE_ASSET__Dinp$2sX__"